<template>
    <b-badge
      pill
      class="d-flex align-items-center py-2 px-3"
      :class="badgeClass"
    >
      <span 
        class="d-inline-block rounded-circle mr-1"
        :class="dotClass"
        style="width: 8px; height: 8px;"
      ></span>
      <span class="small">
        <slot></slot>
      </span>
    </b-badge>
  </template>
  
  <script>
  export default {
    props: {
      color: {
        type: String,
        default: "info",
        validator: function(value) {
          return ['primary', 'secondary', 'success', 'danger', 'warning', 'info'].includes(value)
        }
      }
    },
    computed: {
      badgeClass() {
        return {
          [`badge-soft-${this.color}`]: true,
          [`text-${this.color}`]: true
        }
      },
      dotClass() {
        return {
          [`bg-${this.color}`]: true
        }
      }
    }
  };
  </script>
  
  <style scoped>
  /* Create soft background colors for badges */
  .badge-soft-primary {
    background-color: rgba(var(--primary-rgb), 0.1);
  }
  .badge-soft-secondary {
    background-color: rgba(var(--secondary-rgb), 0.1);
  }
  .badge-soft-success {
    background-color: rgba(var(--success-rgb), 0.1);
  }
  .badge-soft-danger {
    background-color: rgba(var(--danger-rgb), 0.1);
  }
  .badge-soft-warning {
    background-color: rgba(var(--warning-rgb), 0.1);
  }
  .badge-soft-info {
    background-color: rgba(var(--info-rgb), 0.1);
  }
  
  /* Make badges a bit more padded and rounded */
  .badge {
    font-weight: 600;
    letter-spacing: 0.3px;
  }
  </style>